// extracted by mini-css-extract-plugin
module.exports = {"postTitle":"cl_nk","postTitle_size_1":"cl_nl","postTitle_size_2":"cl_nm","postTitle_size_3":"cl_nn"};